<div class="app-container" [attr.data-theme]="modernThemeService.currentTheme">
    <router-outlet></router-outlet>
    <app-footer *ngIf="!(location == '/login' || location == '/register' || location == '/coming-soon')"></app-footer>
    <app-theme-customizer></app-theme-customizer>
    <div *ngIf="loadingService.loading$ | async" class="modern-loading-overlay">
      <div class="modern-loading-spinner">
        <img src="./assets/logo.png" alt="Loading..." class="loading-logo">
        <div class="modern-loading"></div>
      </div>
    </div>
</div>